<template>
    <div>
        <v-chip
            v-if="+item.acrescimo_valor"
            color="cyan"
            class="white--text ml-2"
            small
        >
            <span>
                + {{ formatMoney(item.acrescimo_valor, '') }}
            </span>
        </v-chip>
        <v-chip
            v-if="+item.acrescimo_percentual"
            color="cyan"
            class="white--text ml-2"
            small
        >
            <span>
                + {{ formatNumero(item.acrescimo_percentual) }}%
            </span>
        </v-chip>
        <v-chip
            v-if="+item.desconto_valor"
            color="success"
            class="white--text ml-2"
            small
        >
            <span>
                - {{ formatMoney(item.desconto_valor, '') }}
            </span>
        </v-chip>
        <v-chip
            v-if="+item.desconto_percentual"
            color="success"
            class="white--text ml-2"
            small
        >
            <span>
                - {{ formatNumero(item.desconto_percentual) }}%
            </span>
        </v-chip>
    </div>
</template>

<script>
export default {
    name: 'AcrescimoDescontoChips',

    props: {
        item: {
            type: Object,
        },
    },
}
</script>
